<template>
  <!-- TODO handle i18n -->
  <div class="cb-hp" :class="{'cb-hp--hidden': !isAndroidInstagram()}" tabindex="0" lang="en" role="dialog" aria-labelledby="dialog1Title" aria-describedby="dialog1Desc">
    <h2 class="no-display" id="dialog1Title">Billing Modal</h2>
    <p class="no-display" id="dialog1Desc">Billing modal powered by Chargebee</p>
    <router-view v-if="inited"></router-view>
    <grecaptcha-text v-if="recaptchaTextEnabled"/>
    <div class="cb-hp__close" :class="{'cb-hp__close--inside': isMobileIframe, 'cb-hp__close--show': isMobileIframe && show_iframe_close}" v-if="!hideClose" @click="close" v-cb-link = "'shadow'" role="button" aria-label="close checkout" data-cb-id="cb_close" v-on:keydown="closeKey">
      <i class="icon-remove cb-hp__close-icon"></i>
    </div>
  </div>
</template>
<style src="@/assets/styles/app.styl" lang="stylus"></style>
<style src="@/assets/styles/base/_fonts.styl" lang="stylus" scoped></style>
<script>
import { mapGetters } from "vuex"
import { isOpenedInsideAnIframe } from "@/utils/helper-functions"
import UrlHelper from "@/utils/url-helper"
import GrecaptchaText from '@/components/collections/elements/GrecaptchaText'
import RecaptchaUtil from '@/utils/recaptcha'
import triggerBeacon from '@/beacon'
import apiClient from "@/utils/cb-client"
import { getCheckoutAppShell } from '@/utils/checkout-app-shell'

export default {
    name: 'app',
    data() {
      return {
        transitionName: "",
        initRetryCount: 0,
        initRetryTimerId: null,
        initInfoPromise: null
      }
    },
    created() {
        this.initAppWithRetry();
        addEventListener("beforeunload", triggerBeacon(this.$store));
    },
    beforeUnmount() {
        if (this.initRetryTimerId) {
          clearTimeout(this.initRetryTimerId);
          this.initRetryTimerId = null;
        }
    },
    mounted() {
        this.transitionName = "fadeMain";

        document.body.addEventListener("keydown", (event) => {
          if (event.keyCode == 27) {
            this.close();
          }
        });

        // If v-cb-animate never runs (e.g. router-view inside v-if) or getAppEl missed the shell,
        // cb-hp--hidden can stick forever. Clear after the normal appear animation window (~400ms).
        const clearStuckHidden = () => {
          const shell = getCheckoutAppShell();
          if (shell && shell.classList.contains('cb-hp--hidden') && typeof window.removeClass === 'function') {
            window.removeClass(shell, 'cb-hp--hidden');
          }
        };
        this.$nextTick(() => {
          window.setTimeout(clearStuckHidden, 500);
        });
    },
    methods: {
      getLocaleFromUrl() {
        try {
          const params = new URLSearchParams(window.location.search || "");
          return params.get("locale") || "en";
        } catch (error) {
          return "en";
        }
      },
      fetchInitInfoFromApi() {
        if (this.initInfoPromise) {
          return this.initInfoPromise;
        }
        const locale = this.getLocaleFromUrl();
        if (window.__cb_debug) {
          console.warn("CB_BOOT: fetching initInfo via API", { locale });
        }
        this.initInfoPromise = apiClient.field_configs
          .retrieve_init_info({ locale })
          .then((data) => {
            window.initInfo = data;
            return data;
          })
          .catch((error) => {
            if (window.__cb_debug) {
              console.error("CB_BOOT: initInfo fetch failed", error);
            }
            return null;
          })
          .finally(() => {
            this.initInfoPromise = null;
          });
        return this.initInfoPromise;
      },
      initAppWithRetry() {
        if (this.inited) {
          return;
        }
        const legacyInitInfo = (typeof initInfo !== "undefined") ? initInfo : undefined;
        if (!window.initInfo && legacyInitInfo) {
          window.initInfo = legacyInitInfo;
        }
        if (!window.initInfo) {
          if (window.__cb_debug && this.initRetryCount === 0) {
            console.warn("CB_BOOT: window.initInfo missing, retrying");
          }
          if (this.initRetryCount === 0) {
            this.fetchInitInfoFromApi();
          }
          if (this.initRetryCount < 200) {
            this.initRetryCount += 1;
            this.initRetryTimerId = window.setTimeout(() => this.initAppWithRetry(), 50);
          } else if (window.__cb_debug) {
            console.error("CB_BOOT: window.initInfo still missing after retries");
          }
          return;
        }
        this.$store.dispatch('init_app').then(() => {
          if (window.__cb_debug) {
            console.info("CB_BOOT: init_app completed", { inited: this.inited });
          }
        }).catch((error) => {
          if (window.__cb_debug) {
            console.error("CB_BOOT: init_app failed", error);
          }
        });
      },
      // TODO DRY the code
      isAndroidInstagram() {
        return UrlHelper.isAndroidInstagram();
      },
      close() {
        window.cbPostMessage("cb.close");
        if(window.parent == window){
          // window.close();
        }
      },
      closeKey(event) {
        if(event.keyCode == 9) {
          window.cbFocusAppRoot();
        }
      }
    },
    computed: {
      ...mapGetters(
        [
            'authenticated',
            'inited',
            'show_iframe_close'
        ]
      ),
      hideClose() {
        return !this.show_iframe_close && !window.isOpenedByCb && isOpenedInsideAnIframe();
      },
      isMobileIframe() {
        return window.isOpenedByCb && window.isMobileResolution && isOpenedInsideAnIframe();
      },
      recaptchaTextEnabled() {
        return RecaptchaUtil.isRecaptchaTextEnabled();
      }
    },
    components: {
      'grecaptcha-text': GrecaptchaText
    }
}
</script>
